import api from 'Application/api/api';

const editCampaign = async (signal, values) => {
	const response = await api.put('/finances', values, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default editCampaign;
